export const TRANSACTION_FETCH = 'TRANSACTION_FETCH';
export const TRANSACTION_RECALL = 'TRANSACTION_RECALL';
export const TRANSACTION_GENERATE_GO = 'TRANSACTION_GENERATE_GO';
export const TRANSACTION_MANUAL_ISSUE = 'TRANSACTION_MANUAL_ISSUE';
